import { useEffect, useState } from 'react'
import { confirmable, createConfirmation, ReactConfirmProps } from 'react-confirm'
import {
  ConfirmCheckboxOption,
  ConfirmWithCheckboxesModal,
} from 'stories/components/ConfirmWithCheckboxesModal/ConfirmWithCheckboxesModal'

const ConfirmWithCheckboxesDialog = ({
  show,
  proceed,
  confirmation,
  options,
  checkboxes,
  childLevel,
}: ReactConfirmProps | any) => {
  const [lastUpdatedAt, setLastUpdatedAt] = useState(Date.now())
  useEffect(() => {
    setLastUpdatedAt(Date.now())
  }, [show])

  return (
    <ConfirmWithCheckboxesModal
      isOpen={show}
      onOk={(values) => proceed(values as any)}
      onCancel={() => proceed(false as any)}
      lastUpdatedAt={lastUpdatedAt}
      content={confirmation}
      options={options}
      checkboxes={checkboxes}
      childLevel={childLevel}
    />
  )
}

const confirmWithCheckboxesDlg = confirmable(ConfirmWithCheckboxesDialog)
const createConfirmWithCheckboxes = createConfirmation(confirmWithCheckboxesDlg)

export type ConfirmWithCheckboxesResult = false | Record<string, boolean>

/**
 * Returns checkbox values when Yes is clicked, or `false` when No/Cancel is clicked.
 * Extensible: pass more checkbox options as needed.
 */
export const confirmWithCheckboxes = (
  content: string | JSX.Element,
  checkboxes: ConfirmCheckboxOption[] = [],
  options: Record<string, any> = {},
  childLevel: number = 1,
): Promise<ConfirmWithCheckboxesResult> =>
  createConfirmWithCheckboxes({
    confirmation: content,
    checkboxes,
    options,
    childLevel,
  }) as unknown as Promise<ConfirmWithCheckboxesResult>
